module.exports = __webpack_public_path__ + "static/media/feature.68c87301.jpg";